import { TokenAmount } from 'config/types'
import { useAppDispatch } from 'state'
import { useTokenAppBalance } from 'state/profile/hooks'
import { selectPlayBalance } from 'state/session/actions'
import { useTokenSelected } from 'state/session/hooks'

export const useSelectedBalance = () => {
  const dispatch = useAppDispatch()

  const selectedToken = useTokenSelected()
  const selectedBalance = useTokenAppBalance(selectedToken)

  const handleSelectBalance = (amount: TokenAmount) => {
    dispatch(selectPlayBalance({ token: amount.token }))
  }

  return {
    selectedBalance,
    handleSelectBalance,
  }
}
